export default "__VITE_ASSET__rBCVYRAs__"